module.exports = __webpack_public_path__ + "img/฿.dcde1708.svg";